import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { UniversalPageLayout } from '../../components/BaseComponents'
import routes from '../../components/Router/routes'
import { useCarbonAccountsZones } from './useCarbonAccountsZones'
import { CarbonAccountsGranularityId } from './carbonAccountsGranularities'

const CarbonAccountsPage = () => {
	const { state } = useLocation()
	const [granularity, setGranularity] = useState<CarbonAccountsGranularityId>('suppliers')

	useEffect(() => {
		if (state === 'suppliers') {
			setGranularity('suppliers')
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const zones = useCarbonAccountsZones({ granularity, setGranularity })

	return (
		<UniversalPageLayout
			documentTitle={routes.companyCarbonAccounts.name}
			heading={{
				crumbs: [
					{ label: 'Purchases', route: routes.companyPurchases.path },
					{ label: routes.companyCarbonAccounts.menuName as string },
				],
			}}
			primarySelector={zones.primarySelector}
			viewSelector={zones.viewSelector}
			summary={zones.summary}
			tabs={zones.tabs}
			filtersSimple={zones.filtersContent}
			actions={zones.actions}
		>
			{zones.table}
		</UniversalPageLayout>
	)
}

export default CarbonAccountsPage
